import {
  getUniqueShipmentDeliveryCodes,
  getTotalStopTime,
} from "../../util";
import { getStopStatusCodesWithDescriptions } from "../../stopStatusCodesUtils";
import PickupDeliveryPopupRenderer from "./PickupDeliveryPopupRenderer";
import { getStopDetails } from "./utils";
import constants from "./constants";
import StopTime from "./common/CompletedStopTimeRenderer";

const DeliveryReturnStopPopup = ({
  task,
  DispatchStore,
  enableReturnExceptionReasonLabels = false,
  enableRevisitDeliveryStop = false
}) => {
  const { stopStatus, stopStatusClass } = getStopDetails(task.data);
  const codes = getUniqueShipmentDeliveryCodes(task.data);
  const returnCodeList = DispatchStore?.returnCodes || [];
  const exceptionList = DispatchStore?.exceptions || [];
  const stopStatusCodes = getStopStatusCodesWithDescriptions(
    codes,
    returnCodeList,
    exceptionList,
    enableReturnExceptionReasonLabels
  );
  const plannedStopTime = getTotalStopTime(
    task?.data?.plannedArrivalTime,
    task?.data?.plannedDepartureTime
  )
  return (
    <PickupDeliveryPopupRenderer
      stopType={task?.data?.stopType}
      isReturn
      arrivalTime={task.arrivalTime}
      departureTime={task.departureTime}
      stopTime={<StopTime actualStopTime={task.stopDuration} plannedStopTime={plannedStopTime} />}
      stopTimeClass="completedStopTime"
      stopTimeHeaderClass="completedStopTimeHeader"
      statusLabel={constants.POPUP_LABELS.STATUS}
      statusValue={stopStatus}
      stopStatusClass={stopStatusClass}
      serviceWindow={task?.data}
      statusCodes={stopStatusCodes}
      stopData={task.data}
      enableRevisitDeliveryStop={enableRevisitDeliveryStop}
    />
  );
};

export default DeliveryReturnStopPopup;
